import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Checkbox from './Checkbox';
import style from '../style/components/BiometricsModal.module.scss';
import StyledModal from './StyledModal';

const BiometricsModal = ({
  isChecked,
  isFetching,
  isOpen,
  handleCancel,
  handleChange,
  handleConfirm,
}) => {
  const { t } = useTranslation();

  const privacyLink = (
    <a
      href="https://www.id.me/biometric"
      rel="noopener noreferrer"
      target="_blank"
    >
      Biometric Data Privacy Policy
    </a>
  );

  return (
    <StyledModal
      isOpen={isOpen}
      closeModal={handleCancel}
      submitting={isFetching}
      title={t('biometric.consent.title')}
      wrapper={(children) => (
        <form className={style.form} onSubmit={handleConfirm}>
          {children}
        </form>
      )}
      primaryButton={{
        text: t('biometric.consent.button_continue'),
        action: handleConfirm,
        disabled: !isChecked,
      }}
      cancelButton={{ hidden: true }}
      wideModal
    >
      <div className={style.body}>
        <p>{t('biometric.consent.description_purpose')}</p>
        <p>{t('biometric.consent.description_dataTypes')}</p>
        <p className={style.background}>
          {t('biometric.consent.description_disclaimer')}
        </p>
        <p>
          <Trans
            i18nKey="biometric.consent.description_acknowledgment"
            components={{ privacyLink }}
          />
        </p>
      </div>

      <Checkbox id="biometric" onChange={handleChange} checked={isChecked}>
        {t('biometric.consent.label_checkbox')}
      </Checkbox>
    </StyledModal>
  );
};
export default BiometricsModal;
